<header class="header">
  <div class="shadow-cont">
    <div class="container">
      <div class="row">
        @if (isAuthenticated) {
          <div class="col-xl-2 col-3 logo">
            <a href="javascript:;" [routerLink]="['dashboard']" title="Pibank"
              ><img class="img-fluid" src="./assets/img/logotipo.svg" alt="Pibank"
            /></a>
          </div>
        } @else {
          <div class="col-xl-2 col-3 logo">
            <a href="https://www.pibank.es/" title="Pibank"
              ><img class="img-fluid" src="./assets/img/logotipo.svg" alt="Pibank"
            /></a>
          </div>
        }

        <!--  <div class="col-lg-5 col-sm-12 offset-lg-3 offset-sm-0 padding-top-24">
               <form class="text-align-right" [formGroup]="loginForm" (ngSubmit)="login(loginForm.value, loginForm.valid)">
                <select *ngIf="!isAuthenticated" class="col-lg-8 col-xs-12 bold" formControlName="office">
                    <option value="">Selecciona tu oficina</option>
                    <option *ngFor="let office of offices" [ngValue]="office">{{ office.street }}</option>
                </select>
                <p *ngIf="isAuthenticated" class="col-lg-8 col-xs-12">{{ office.street }}</p>
                <button *ngIf="!isAuthenticated" class="col-lg-4 col-xs-12 filled" type="submit" value="login" [disabled]="!loginForm.valid">Entrar</button>
                <button *ngIf="isAuthenticated" class="col-lg-4 col-xs-12 filled" (click)="logout()">Salir</button>
            </form>
            </div>-->

        @if (!isSecondHolder) {
          <div class="col-xl-10 col-9 nav-container" [hidden]="hiddenBtn">
            <!-- este menú solo se ve una vez estás logado -->

            @if (isAuthenticated) {
              <a href="javascript:;" (click)="toggleMenu()" class="menu menu-link" title="Menú"
                ><span class="ic ic-menu-mobile menu-link"></span
              ></a>
            }

            @if (showMenu) {
              <div
                class="menu-dropdown"
                [ngStyle]="{ display: !isMenuOpen ? 'none' : 'block' }"
                appClickOutside
                (outside)="hideMenu()"
                [ignoreClass]="['menu-link']"
              >
                <ul>
                  <li class="home-mobile">
                    <a
                      class="menu-home"
                      id="header-menu-home"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="LAYOUT_URL"
                      title="Home"
                      ><span class="ic ic-home-pi no-pd"></span>{{ 'Inicio' | translate }}</a
                    >
                  </li>
                  <li [ngClass]="{ 'menu-disabled': status === 0 || isRejected }">
                    <a
                      id="header-menu-econimic-study"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="canNavigateToEconomicStudy ? ECONOMIC_STUDY_URL : RESULT_URL"
                      title="Tu solicitud"
                      ><span class="ic ic-mortage"></span>{{ 'header_menu_your_request' | translate }}</a
                    >
                  </li>
                  <li>
                    <a
                      id="header-menu-wall"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="WALL_IN_URL"
                      title="Tus mensajes"
                      ><span class="ic ic-envelope"></span>{{ 'header_menu_wall' | translate }}</a
                    >
                  </li>
                  <li [ngClass]="{ 'menu-disabled': status < minStatus.attachDocumentation || isRejected }">
                    <a
                      id="header-menu-documentation"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="DOCUMENTATION_URL"
                      title="Documentación"
                    >
                      <span class="ic ic-document"></span> {{ 'header_menu_documentation' | translate }}</a
                    >
                  </li>
                  <li [ngClass]="{ 'menu-disabled': status < minStatus.appraisal || isRejected }">
                    <a
                      id="header-menu-appraisal"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="APPRAISAL_URL"
                      title="Tasación"
                    >
                      <span class="ic ic-location"></span> {{ 'header_menu_appraisal' | translate }}</a
                    >
                  </li>
                  <li [ngClass]="{ 'menu-disabled': status < minStatus.signature || isRejected }">
                    <a
                      id="header-menu-sign"
                      href="javascript:;"
                      (click)="hideMenu()"
                      [routerLink]="SIGN_IN_URL"
                      title="Firma"
                      ><span class="ic ic-edit"></span> {{ 'header_menu_signature' | translate }}
                    </a>
                  </li>
                  <div class="menu menu-link mobile logut-content row">
                    <div class="col-12">
                      <a class="nav-link" href="javascript:void(0)">{{ email }} </a>
                    </div>
                    <div class="col-12">
                      <button
                        id="header-pibank-btn-logout-menu"
                        class="btn btn-01"
                        type="button"
                        (click)="confirmLogout()"
                      >
                        {{ 'header_btn_logout' | translate }}
                      </button>
                    </div>
                  </div>
                </ul>
              </div>
            }

            @if (isAuthenticated) {
              <a
                class="menu-home"
                id="header-menu-home"
                href="javascript:;"
                (click)="hideMenu()"
                [routerLink]="LAYOUT_URL"
                title="Volver al inicio"
                ><span class="ic ic-home-pi"></span>{{ 'Inicio' | translate }}</a
              >
            }

            <nav class="">
              @if (isAuthenticated) {
                <div class="nav-container row">
                  <div class="nav-is-logged col-sm-9 col-12 no-pd">
                    @if (email) {
                      <a class="nav-link email truncate" href="javascript:void(0)" ngxClipboard [cbContent]="email"
                        >{{ email }}
                      </a>
                    }

                    @if (emailLoaded && !email) {
                      <a class="nav-link email truncate" href="javascript:void(0)">{{
                        'header_error_email' | translate
                      }}</a>
                    }
                  </div>
                  <div class="col-sm-3 col-12 logout-btn">
                    <button
                      id="header-pibank-btn-logout"
                      class="filled btn btn-01"
                      type="button"
                      (click)="confirmLogout()"
                    >
                      {{ 'header_btn_logout' | translate }}
                    </button>
                  </div>
                </div>
              }
              <!-- <a id="btn-header-register" class="btn btn-01 menu-btn" href="javascript:void(0)" (click)="recoverRequest(true)" *ngIf="!isAuthenticated"> {{ 'header_btn_simulador_avanzado' | translate }} </a> -->

              @if (!isAuthenticated) {
                <a
                  id="btn-header-login"
                  class="btn btn-01 menu-btn"
                  href="javascript:void(0)"
                  (click)="recoverRequest()"
                  >{{ 'header_btn_login' | translate }}</a
                >
              }
              <!-- Este menú solo se ve en el presimulador no logado versión mobile (controlado por css) -->
              <!-- <a *ngIf="!isAuthenticated && !showMenu" href="javascript:;" (click)="toggleMenu()" class="menu menu-link mobile" title="Menú"><span class="ic ic-menu-mobile menu-link"></span></a>
                          <div *ngIf="!isAuthenticated && !showMenu" class="menu-dropdown mobile" [ngStyle]="{'display': !isMenuOpen ? 'none' : 'block'}" appClickOutside (outside)="hideMenu()" [ignoreClass]="['menu-link']">
                              <ul>
                                  <li><a id="btn-header-register-menu" href="javascript:;" (click)="recoverRequest(true)">{{ 'simulation_content_btn_request_custom_study' | translate }}</a></li> -->
              <!--   <li><a id="btn-header-login-menu" href="javascript:;" (click)="recoverRequest()"> {{ 'header_btn_login' | translate }} </a></li>
                              </ul>
                          </div>-->
            </nav>
          </div>
        }

        @if (isSecondHolder) {
          <div class="col-9 nav-container">
            <nav class="d-flex justify-content-end">
              @if (isAuthenticated) {
                <div class="nav-container row">
                  <div class="nav-is-logged col-sm-7 col-12 no-pd">
                    @if (email) {
                      <a class="nav-link email truncate" href="javascript:void(0)" ngxClipboard [cbContent]="email"
                        >{{ email }}
                      </a>
                    }

                    @if (emailLoaded && !email) {
                      <a class="nav-link email truncate" href="javascript:void(0)"
                        >{{ 'header_error_recover_email' | translate }}
                      </a>
                    }
                  </div>
                  <div class="col-sm-5 col-11 logout-btn-sencond-holder">
                    <button
                      id="header-pibank-btn-logout"
                      class="filled btn btn-01"
                      type="button"
                      (click)="confirmLogout()"
                    >
                      {{ 'header_btn_logout' | translate }}
                    </button>
                  </div>
                </div>
              }
            </nav>
          </div>
        }
      </div>
    </div>
  </div>

  @if (!isAuthenticated && !hiddenBtn) {
    <div class="sub-header">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
            <p>{{ 'header_already_started' | translate }}</p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 no-pd">
            <a id="btn-header-login" class="btn btn-01" href="javascript:void(0)" (click)="recoverRequest()">{{
              'header_btn_login' | translate
            }}</a>
          </div>
        </div>
      </div>
    </div>
  }
</header>
